import { render, staticRenderFns } from "./v-modal.vue?vue&type=template&id=f8397552&scoped=true&"
import script from "./v-modal.vue?vue&type=script&lang=js&"
export * from "./v-modal.vue?vue&type=script&lang=js&"
import style0 from "./v-modal.vue?vue&type=style&index=0&id=f8397552&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8397552",
  null
  
)

export default component.exports